import { render, staticRenderFns } from "./CustomizeChoicePlusThankYou.vue?vue&type=template&id=18fbed80&"
import script from "./CustomizeChoicePlusThankYou.vue?vue&type=script&lang=js&"
export * from "./CustomizeChoicePlusThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports